/** Internal report comments. Shapes mirror apps/api/src/comment-routes.ts. */

import { apiCall, orgPath } from '../api.ts';

export interface ReportComment {
  id: string;
  parent_id: string | null;
  page_id: string | null;
  widget_id: string | null;
  author_id: string;
  author_name: string;
  body: string;
  mentions: string[];
  resolved_at: string | null;
  created_at: string;
  deleted: boolean;
  can_delete: boolean;
}

export interface CommentThread extends ReportComment {
  replies: ReportComment[];
}

export interface StaffMember {
  user_id: string;
  name: string;
  email: string;
}

export interface NewComment {
  body: string;
  mentions: string[];
  parent_id?: string;
  page_id?: string;
  widget_id?: string;
}

const reports = (org: string, path: string) => orgPath(org, `/reports${path}`);

export const commentsApi = {
  list: (org: string, documentId: string) =>
    apiCall<{ threads: CommentThread[] }>(reports(org, `/documents/${documentId}/comments`)).then(
      (data) => data.threads,
    ),
  add: (org: string, documentId: string, input: NewComment) =>
    apiCall<{ comment: ReportComment }>(reports(org, `/documents/${documentId}/comments`), {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  resolve: (org: string, commentId: string, resolved: boolean) =>
    apiCall<{ comment: ReportComment }>(reports(org, `/comments/${commentId}`), {
      method: 'PATCH',
      body: JSON.stringify({ resolved }),
    }),
  remove: (org: string, commentId: string) =>
    apiCall<{ deleted: boolean }>(reports(org, `/comments/${commentId}`), { method: 'DELETE' }),
  staff: (org: string) =>
    apiCall<{ staff: StaffMember[] }>(reports(org, '/staff')).then((data) => data.staff),
};
